import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IOpportunitiesResponse,
  IOpportunity,
  IOpportunityState,
} from "../@types/opportunity";

const initialState: IOpportunityState = {
  opportunities: [],
  opportunity: null,
  limit: 20,
  offset: 0,
  total: 0,
  loading: false,
  loadingOpportunityId: null,
};

export const opportunity = createSlice({
  name: "opportunity",
  initialState,
  reducers: {
    setOpportunities: (
      state,
      action: PayloadAction<IOpportunitiesResponse>,
    ) => {
      state.opportunities = action.payload.data.data;
      state.limit = action.payload.data.limit;
      state.offset = action.payload.data.offset;
      state.total = action.payload.data.total;
    },
    setOpportunnity: (state, action: PayloadAction<IOpportunity>) => {
      state.opportunity = action.payload;
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setLoadingId: (state, action: PayloadAction<number | null>) => {
      state.loadingOpportunityId = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setOpportunities, setOpportunnity, setLoading, setLoadingId } =
  opportunity.actions;

export default opportunity.reducer;
